import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { withSagas } from 'decorators/Sagas/Sagas';
import { clearAllBanners } from 'features/Banners/Banners.reducer';
import { useReducedFooter, useReducedNavigation } from 'redux/modules/page';
import { cms } from 'redux/saga/entities/bound';
import { watchPagePromotionForModal } from 'redux/saga/helpers/promotions';
import { isEmpty } from 'helpers/verify';
import { CmsPage } from 'components/CmsPage/CmsPage';
import { cmsDataToModuleArray } from 'components/CmsPage/cmsDataToModuleArray';
import { loadCmsPage, watchCmsPageSagas } from 'containers/CmsPage/cms-page.saga';
import { FALLBACK_HERO_DATA } from './fallback-hero';

export const mapStateToProps = (state, props) => {
  const pathForCms = cms.defaultKey(null, props.location.pathname);
  const cmsData = cms.error(state, pathForCms) ? FALLBACK_HERO_DATA : cms.data(state, pathForCms);
  return {
    cmsData,
    hideFooter: cmsData && !!cmsData.hideFooter,
    hideHeader: cmsData && !!cmsData.hideHeader,
    modules: isEmpty(cmsData) ? [] : cmsDataToModuleArray(state, cmsData),
    shouldIgnoreUnhandledError: true,
    path: pathForCms,
  };
};

export const mapDispatchToProps = {
  clearBanners: clearAllBanners,
  loadCmsPage,
  useReducedFooter,
  useReducedNavigation,
};

export const HomepageContainer = decorateWith(
  withSagas({ watch: [watchCmsPageSagas, watchPagePromotionForModal] }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('HomepageContainer')
)(CmsPage);

export default HomepageContainer;
